export const SDK_VERSION = '2.10.1';